(function(){
    'use strict';

    angular
    .module('appback')
    .controller('DocumentacionController', DocumentacionController)
 
    DocumentacionController.$inject = ["$scope","$http","$timeout","$uibModal", "$log", "$document","$sce",'Upload', 'DocumentacionService'];
              
    function DocumentacionController($scope,$http,$timeout,$uibModal, $log, $document,$sce,Upload, DocumentacionService)
    {                         
        var vm = this;
        vm.documentos = [];
        vm.documentosSubidos = [];
        vm.contador = 0;
        vm.filesCount = 0;
        vm.fileNameSummary = '';
        vm.pendiente = false;
        vm.isDragging = false;
        vm.documentos_data = {
            tipodocumento_id: null,
            descripcion: null,
            visible_intranet: false
        }

        vm.triggerUpload = function() {
            document.getElementById('ficheros-input').click();
        };

        vm.updateFiles = function(files) {
            $scope.$apply(function() {
                vm.documentos = files;
                vm.filesCount = files.length;
                if (files.length > 0) {
                    if (files.length === 1) {
                        vm.fileNameSummary = files[0].name;
                    } else {
                        vm.fileNameSummary = files[0].name + " + " + (files.length - 1) + " más";
                    }
                } else {
                    vm.fileNameSummary = '';
                }
            });
        };

        vm.resetForm = function() {
            vm.documentos = [];
            vm.documentosSubidos = [];
            vm.contador = 0;
            vm.filesCount = 0;
            vm.fileNameSummary = '';
            vm.pendiente = false;
            vm.isDragging = false;
            vm.documentos_data = {
                tipodocumento_id: null,
                descripcion: null,
                visible_intranet: false
            };
            if(document.getElementById('ficheros-input')) {
                document.getElementById('ficheros-input').value = "";
            }
        };

        vm.subirDocumentos = function(){
            vm.pendiente = true;
            console.log("subiendo documentos", vm.documentos);
            if(vm.documentos.length > 0){
                Upload.upload({
                    url: '/backend/documentacion/uploaddocumentos',
                    arrayKey: '',
                    data: {
                        'files[]': vm.documentos
                    }
                }).then(function (resp) {
                    console.log("Subida múltiple exitosa", resp);
                    vm.documentosSubidos = resp.data;
                    vm.documentos = [];
                    vm.saveDocumentos();
                }, function (error) {
                    console.error("Error al subir múltiples archivos", error);
                    vm.pendiente = false;
                });
            }
        }

        vm.saveDocumentos = function(){
            console.log("ejecutando saveDocumentos");
            vm.contador = 0;
            vm.subidosConExito = 0;
            vm.docEnProceso = '';

            // Abrir el modal de progreso
            vm.modalProgress = $uibModal.open({
                animation: true,
                templateUrl: 'documentacionProgreso.html',
                size: 'md',
                backdrop: 'static',
                keyboard: false,
                scope: $scope
            });

            function saveNextDoc() {
                if (vm.contador >= vm.documentosSubidos.length) {
                    vm.pendiente = false;
                    vm.docEnProceso = null;
                    
                    // Cerramos el modal de progreso
                    if (vm.modalProgress) {
                        vm.modalProgress.close();
                    }

                    // Abrimos el modal de éxito
                    $uibModal.open({
                        animation: true,
                        templateUrl: 'documentacionSubida.html',
                        size: 'md',
                        backdrop: 'static',
                        scope: $scope
                    }).result.finally(function() {
                        vm.resetForm();
                    });

                    return;
                }

                let documento = vm.documentosSubidos[vm.contador];
                vm.docEnProceso = documento.nombre_original;

                if (documento.saved) {
                    console.log("guardando el documento", documento);
                    DocumentacionService.saveDocumento(vm.documentos_data, documento)
                    .then(function (resp) {
                        console.log("documento guardado", resp);
                        if(resp.data.code > 0){
                            documento.done = true;
                            vm.subidosConExito++;
                        } else {
                            documento.saved = false;
                        }
                        vm.contador++;
                        saveNextDoc(); 
                    }, function (error) {
                        console.error("Error al guardar documento", error);
                        vm.contador++;
                        saveNextDoc();
                    });
                } else {
                    vm.contador++;
                    saveNextDoc(); 
                }
            }

            saveNextDoc(); 
        }   
    }
  
})();